define('plugin/back-to-site/BackToSitePlugin',['require','lib/plugin/PluginAbstract','plugin/back-to-site/model/BackToSiteModel','plugin/back-to-site/view/BackToSiteView'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var BackToSiteModel = require('plugin/back-to-site/model/BackToSiteModel');
    var BackToSiteView = require('plugin/back-to-site/view/BackToSiteView');

    return PluginAbstract.extend({

        _model: null,

        _regions: {
            'backToSiteBlock': '#sb_back_btns_plugin'
        },

        /**
         * On show client bookings page.
         * If we got cart_id we will load cart status from server
         *
         * @param BookingResultView view
         * @param Object data
         */
        onShowClientBookings: function (view, data) {
            this._showBackHome(view, data);
        },

        /**
         * On finish payment
         *
         * @param view
         * @param data
         */
        onFinishPayment: function (view, data) {
            this._showBackHome(view, data);
        },

        _showBackHome: function (view, data) {
            if (data.booking_ids) {
                _.each(this._regions, function (selector, region) {
                    view.addRegion(region, selector);
                });
                if (!this._model) {
                    this._model = new BackToSiteModel();
                    this._model.fetch();
                }
                var btnView = new BackToSiteView({
                    model: this._model
                });
                view.backToSiteBlock.show(btnView);
            }
        }

    });

});
